import {
  can,
  type ChatState,
  PermissionFlags,
  selectChannelTree,
} from '@alternativamais/chat-core';

import { gravarPreferencia, lerPreferencia } from '../../armazenamento/local';
import { abreComoChat } from '@alternativamais/chat-core';

/** Último canal aberto em cada servidor (volta nele, como o Discord). */
export function lembrarCanal(guildId: string, canalId: string) {
  const mapa = lerPreferencia<Record<string, string>>('ultimo-canal', {});
  if (mapa[guildId] === canalId) return;
  gravarPreferencia('ultimo-canal', { ...mapa, [guildId]: canalId });
}

export function rotaDoServidor(guildId: string): string {
  return `/canais/${guildId}`;
}

/** Para onde ir ao abrir o servidor: o último canal visto ou o primeiro que dá para ler. */
export function canalInicial(
  estado: ChatState,
  guildId: string,
): string | null {
  const ultimo = lerPreferencia<Record<string, string>>('ultimo-canal', {})[
    guildId
  ];
  const pode = (id: string) =>
    !!estado.channels[id] &&
    abreComoChat(estado.channels[id]) &&
    can(estado, id, PermissionFlags.VIEW_CHANNEL);
  if (ultimo && pode(ultimo)) return ultimo;
  for (const grupo of selectChannelTree(estado, guildId)) {
    const canal = grupo.channels.find(
      (item) => pode(item.id) && !item.legacy_voice,
    );
    if (canal) return canal.id;
  }
  return null;
}
